import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { GalleryImg } from '../gallery.component'

declare var $: any;
@Component({
  selector: 'app-full-view',
  templateUrl: './full-view.component.html',
  styleUrls: ['./full-view.component.less']
})


export class FullViewComponent implements OnInit {

  carousals: any;
  locImgURL: string;
  currentIndex: number;
  current_img: string;
  currentItem: number;


  constructor(
    public dialogRef: MatDialogRef<FullViewComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {
    this.locImgURL = data.img;
    // console.log(data.img);
    console.log(this.data);
    this.carousals = this.data.carousals_data;
    this.currentIndex = this.data.imgIndex;
    this.current_img = this.data.current_img;
    console.log(this.carousals + "...." + this.currentIndex + "..." + this.current_img);
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  ngOnInit() {
    // setTimeout(() => {
    //   $('#carouselExampleControls').carousel(this.locImgURL);
    // });
    for (var i = 0; i < this.carousals.length; i++) {
      if (this.carousals[i].id == this.currentIndex) {
        this.currentItem = i;
      }
    }
    console.log(this.currentItem);
  }

  Next() {
    this.currentItem++;
    if (this.currentItem > this.carousals.length - 1) {
      this.currentItem = 0;
    }

    this.current_img = this.carousals[this.currentItem].img;
  }
  Prev() {
    this.currentItem--;
    if (this.currentItem < 0) {
      this.currentItem = this.carousals.length - 1;
    }
    this.current_img = this.carousals[this.currentItem].img;
  }

  ngOnDestroy(): void {
    //Called once, before the instance is destroyed.
    //Add 'implements OnDestroy' to the class.
    // this.locImgURL = null;
  }


}
